module.exports = __webpack_public_path__ + "static/media/item-1.810f7c3c.png";